var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMicBan = function SvgMicBan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18.978c-1.73-.708-2.95-2.379-2.954-4.324V6.688C9.046 4.1 11.2 2 13.844 2c2.648 0 4.797 2.105 4.797 4.688v5.321a6.981 6.981 0 0 0-1.664.288V6.688c0-1.687-1.406-3.061-3.133-3.061S10.71 5 10.71 6.688v7.966a3.05 3.05 0 0 0 1.505 2.615A7.015 7.015 0 0 0 12 18.978Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.153 20.463c-2.59-.72-4.488-3.052-4.488-5.809v-3.197a.821.821 0 0 0-.83-.812.825.825 0 0 0-.835.812v3.197c0 3.88 2.964 7.097 6.8 7.598a6.95 6.95 0 0 1-.647-1.789ZM13.014 22.63v1.748h-2.605a.82.82 0 0 0-.83.81c0 .451.374.812.83.812h6.874a.839.839 0 0 0 .431-.118 7.007 7.007 0 0 1-4.7-3.252ZM21.692 12.537v-1.08a.826.826 0 0 0-.834-.816.82.82 0 0 0-.83.81v.624c.58.085 1.139.242 1.664.462Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 19a6 6 0 1 1-12 0 6 6 0 0 1 12 0Zm-1.7 0a4.3 4.3 0 0 1-6.512 3.688l5.803-6.054A4.28 4.28 0 0 1 23.3 19Zm-7.768 2.542 5.86-6.115a4.3 4.3 0 0 0-5.861 6.116Z",
    fill: "#fff"
  })));
};
export default SvgMicBan;